import * as React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { Colors } from "../../utils/Colors";

export default function DoctorStatCard({ title, value, subtitle, icon, valueColor }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 4,
        bgcolor: Colors.bg.paper,
        border: `1px solid ${Colors.border.light}`,
        height: "100%",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography
            variant="body2"
            sx={{ color: Colors.text.muted, fontWeight: 600 }}
          >
            {title}
          </Typography>

          <Typography
            variant="h4"
            sx={{
              mt: 1,
              fontWeight: 800,
              color: valueColor || Colors.text.title,
            }}
          >
            {value}
          </Typography>

          <Typography
            variant="body2"
            sx={{ mt: 0.7, color: Colors.text.sub }}
          >
            {subtitle}
          </Typography>
        </Box>

        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 3,
            bgcolor: Colors.bg.app,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: Colors.brand.primary,
          }}
        >
          {icon}
        </Box>
      </Stack>
    </Paper>
  );
}